<h4>{{TR title}}</h4>
<div class='btn-group'>
    {{#unless hasNoFullscreen}}
        <button class='btn btn-white btn-sm js-fullscreen'><i
                class='fa fa-expand'
            ></i>
        </button>
    {{/unless}}
    {{#if link}}
        <a
            id='js-tile-link-{{id}}'
            href='{{link}}'
            class='btn btn-sm btn-white'
        >
            <i class='fa fa-external-link'></i>
        </a>
    {{/if}}
</div>
